var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIllustrationNoPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 57,
    viewBox: "0 0 85 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5275 0.489354C11.5792 0.226597 11.8095 0.0371094 12.0773 0.0371094L77.0488 0.0371094C77.4016 0.0371094 77.6666 0.359254 77.5985 0.705432L66.7532 55.8934C66.7015 56.1562 66.4712 56.3456 66.2034 56.3456H1.57244C1.04324 56.3456 0.645742 55.8624 0.747787 55.3432L11.5275 0.489354Z",
    fill: "#4793F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5911 0.568521C11.6111 0.259731 11.8672 0.0371094 12.1766 0.0371094L77.094 0.0371094C77.4314 0.0371094 77.6923 0.333169 77.6498 0.667909L70.6484 55.8559C70.6129 56.1358 70.4156 56.3457 70.1334 56.3457C64.9101 56.3456 16.0426 56.3456 4.16239 56.3456C3.15172 56.3456 2.51406 55.2368 2.88604 54.2971C7.64615 42.2718 11.2573 5.72335 11.5911 0.568521Z",
    fill: "#A8CCF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6129 0.520603C11.6379 0.231033 11.8778 0.0371094 12.1685 0.0371094L77.1366 0.0371094C77.4586 0.0371094 77.7144 0.307906 77.696 0.629397L74.5384 55.8184C74.5215 56.1145 74.318 56.346 74.0215 56.3466C68.024 56.3584 8.60993 56.4736 7.711 56.414C6.81585 56.3547 11.139 6.00775 11.6129 0.520603Z",
    fill: "#648CFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6023 0.559445C11.6102 0.256146 11.8578 0.0371094 12.1612 0.0371094L77.1845 0.0371094C77.488 0.0371094 77.7363 0.278714 77.7446 0.582068L79.2547 55.77C79.2633 56.0854 79.0415 56.3456 78.726 56.3456C72.5625 56.3456 16.0861 56.3456 13.1569 56.3456C10.2341 56.3456 11.4545 6.24022 11.6023 0.559445Z",
    fill: "#2538BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6747 0.657219C11.6436 0.32852 11.9015 0.0371094 12.2317 0.0371094L77.1766 0.0371094C77.4832 0.0371094 77.733 0.274946 77.7384 0.581522C77.8255 5.56823 78.656 43.3664 83.9555 53.7351C84.1357 54.0876 83.9463 54.5105 83.5541 54.5644C72.7009 56.057 28.0522 56.3157 22.3103 56.343C21.9455 56.3447 21.6234 56.1076 21.5111 55.7605C16.1609 39.2237 14.1159 26.4656 11.6747 0.657219Z",
    fill: "#A8CCF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6682 0.645146C11.6402 0.318064 11.8982 0.0371094 12.2265 0.0371094L77.1868 0.0371094C77.4894 0.0371094 77.7373 0.277315 77.7468 0.579719L78.0403 9.87822L12.4205 9.43877L11.6682 0.645146Z",
    fill: "#4793F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0825 15.5308H69.7301L70.7076 21.1784H65.06L64.0825 15.5308Z",
    fill: "#648CFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0908 15.5308H59.7384L60.7159 21.1784H55.0683L54.0908 15.5308Z",
    fill: "#648CFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0986 15.5308H49.7462L50.7237 21.1784H45.0761L44.0986 15.5308Z",
    fill: "#648CFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8198 24.0024H71.4674L72.4449 29.65H66.7973L65.8198 24.0024Z",
    fill: "#648CFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8276 24.0024H61.4752L62.4527 29.65H56.8051L55.8276 24.0024Z",
    fill: "#648CFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8359 24.0024H51.4835L52.461 29.65H46.8134L45.8359 24.0024Z",
    fill: "#E7F1FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8438 24.0024H41.4914L42.4688 29.65H36.8212L35.8438 24.0024Z",
    fill: "#E7F1FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8521 24.0024H31.4997L32.4771 29.65H26.8295L25.8521 24.0024Z",
    fill: "#E7F1FD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3403 33.125H72.9879L73.9654 38.7726H68.3178L67.3403 33.125Z",
    fill: "#648CFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3481 33.125H62.9957L63.9732 38.7726H58.3256L57.3481 33.125Z",
    fill: "#648CFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3564 33.125H53.0041L53.9815 38.7726H48.3339L47.3564 33.125Z",
    fill: "#648CFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3643 33.125H43.0119L43.9893 38.7726H38.3417L37.3643 33.125Z",
    fill: "#FFBF39"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3726 33.125H33.0202L33.9976 38.7726H28.35L27.3726 33.125Z",
    fill: "#648CFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0859 42.2485H64.7335L65.711 47.8961H60.0634L59.0859 42.2485Z",
    fill: "#648CFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0942 42.2485H54.7418L55.7193 47.8961H50.0717L49.0942 42.2485Z",
    fill: "#648CFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1025 42.2485H44.7501L45.7276 47.8961H40.08L39.1025 42.2485Z",
    fill: "#E7F1FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1104 42.2485H34.758L35.7354 47.8961H30.0878L29.1104 42.2485Z",
    fill: "#E7F1FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIllustrationNoPen);
export default __webpack_public_path__ + "static/media/calendar-illustration-no-pen.4657893ee02dee43cbec8d5b40e530c0.svg";
export { ForwardRef as ReactComponent };